import React from 'react'
import { Box } from '@mui/material'
import {
  DataGrid,
  GridSortModel,
  GridPaginationModel,
  GridColDef,
} from '@mui/x-data-grid'
import { Message } from '../../../services/campaignApi'
import campaignApi from '../../../services/campaignApi'
import { DynamicColumnMenu } from '../../common/table'

const FILTERABLE_COLUMNS: Record<string, string> = {
  status: 'Status',
  lead_name: 'Lead Name',
  lead_phone: 'Phone',
}

export interface DesktopMessageListProps {
  apiRef: any
  messages: Message[]
  messageColumns: GridColDef[]
  isLoading: boolean
  totalMessages: number
  paginationModel: GridPaginationModel
  setPaginationModel: (model: GridPaginationModel) => void
  sortModel: GridSortModel
  setSortModel: (model: GridSortModel) => void
  campaignId: string
  dynamicFilters: Record<string, string[]>
  setDynamicFilters: React.Dispatch<React.SetStateAction<Record<string, string[]>>>
  renderNoRowsOverlay: () => React.ReactNode
  renderLoadingOverlay: () => React.ReactNode
}

export const DesktopMessageList: React.FC<DesktopMessageListProps> = ({
  apiRef,
  messages,
  messageColumns,
  isLoading,
  totalMessages,
  paginationModel,
  setPaginationModel,
  sortModel,
  setSortModel,
  campaignId,
  dynamicFilters,
  setDynamicFilters,
  renderNoRowsOverlay,
  renderLoadingOverlay,
}) => {
  const fetchFilterValues = React.useCallback(
    (columnName: string, offset?: number, sortOrder?: string) =>
      campaignApi.getCampaignMessagesStatsFilters(campaignId, columnName, 20, offset, sortOrder),
    [campaignId]
  )

  return (
    <Box sx={{ width: '100%', height: 632 }}>
      <DataGrid
        apiRef={apiRef}
        rows={messages}
        columns={messageColumns}
        loading={isLoading}
        rowCount={totalMessages}
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[10, 25, 50]}
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={setSortModel}
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: renderNoRowsOverlay,
          loadingOverlay: renderLoadingOverlay,
          columnMenu: DynamicColumnMenu,
        }}
        slotProps={{
          columnMenu: {
            filterableColumns: FILTERABLE_COLUMNS,
            fetchFilterValues,
            cachePrefix: campaignId,
            dynamicFilters,
            setDynamicFilters,
            sortModel,
          } as any,
          basePopper: {
            popperOptions: {
              strategy: 'fixed',
              modifiers: [
                {
                  name: 'flip',
                  enabled: true,
                  options: {
                    fallbackPlacements: ['top-end', 'top-start', 'bottom-end', 'bottom-start'],
                    padding: 8,
                  },
                },
                {
                  name: 'preventOverflow',
                  enabled: true,
                  options: {
                    boundary: 'window',
                    altAxis: true,
                    padding: 8,
                  },
                },
              ],
            },
          },
        }}
      />
    </Box>
  )
}
